import { Button, CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { availabilityModalStyles } from "styles/AvailabilityDirectory/availabilityModal.styles";

interface DeleteItemModalProps {
  open: boolean;
  close: () => void;
  loading: boolean;
  onSubmit: any;
  customStyle?: object;
  sx?: object;
}

export default function DeleteAvailabilityModal({
  open,
  close,
  loading,
  onSubmit,
  customStyle = {},
  sx = {},
}: DeleteItemModalProps) {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box sx={{ ...availabilityModalStyles.modalStyles, ...customStyle }}>
        {/* Modal Title */}
        <Typography sx={availabilityModalStyles.headerText} textAlign="center">
          Delete Availability
        </Typography>

        {/* Modal Body */}
        <Box mt="15px">
          <Typography sx={availabilityModalStyles.bodyText} textAlign="center">
            Are you sure you want to delete this availability?
          </Typography>
        </Box>

        {/* Modal Footer */}
        <Box sx={availabilityModalStyles.modalFooter}>
          <Button sx={availabilityModalStyles.greenButton} onClick={onSubmit}>
            {loading ? (
              <CircularProgress
                sx={availabilityModalStyles.circularProgress}
                size={20}
              />
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            variant="outlined"
            sx={availabilityModalStyles.whiteButton}
            onClick={close}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
